import { fetchSbLinks } from "@/features/storyblok/lib/api"

export const getCategories = async (path: string) => {
    const links = await fetchSbLinks({ starts_with: path })

    const paths = links
        .filter(({ is_startpage, slug }) => is_startpage && slug !== path)
        .map(({ slug }) => `/${slug}`)

    return {
        paths,
        fallback: true,
    }
}
